export const MAX_WIDTH = 720;
export const MAX_HEIGHT = 720;
export const JPEG_QUALITY = 0.5;

export default {
  MAX_WIDTH,
  MAX_HEIGHT,
  JPEG_QUALITY,
};
